import React, { useState, useEffect, useRef } from 'react';

import { PortfolioProvider } from '../../context/context';

import {
  heroData,
  aboutData,
  projectsData,
  contactData,
  footerData,
  portBlogsData,
} from '../../mock/data';
import ResumeHero from '../ResumeHero/ResumeHero';
import Projects from '../Projects/Projects';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';
import { Scrollbars } from 'react-custom-scrollbars';
import BlogsBlock from '../BlogsBlock/BlogsBlock';
import CursorComponent from '../CursorComponent';

function Resume(props) {
  const [hero, setHero] = useState({});
  const [about, setAbout] = useState({});
  const [projects, setProjects] = useState([]);
  const [contact, setContact] = useState({});
  const [footer, setFooter] = useState({});
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    setHero({ ...heroData });
    setAbout({ ...aboutData });
    setProjects([...projectsData]);
    setBlogs([...portBlogsData]);
    setContact({ ...contactData });
    setFooter({ ...footerData });
  }, []);


  return (
    <Scrollbars style={{ height: '100vh', width: '100%' }}>
      <PortfolioProvider value={{ hero, about, projects, contact, blogs, footer }}>
        <ResumeHero />
        <Projects />
        <BlogsBlock />
        <Contact />
        <Footer />
        <CursorComponent />
      </PortfolioProvider>
    </Scrollbars>
  );
}

export default Resume;
